import sdl from '@jds/react-generated-sdl/JDSDatepickerMonthView';
import type { JDSDatepickerMonthViewProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerMonthViewProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSDatepickerMonthView',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerMonthView = withLogic(
  Component
) as React.FC<JDSDatepickerMonthViewProps> & { slotName?: string };

DatepickerMonthView.displayName = 'DatepickerMonthView';
DatepickerMonthView.slotName = 'jds_datepicker_month_view';

export { DatepickerMonthView, type JDSDatepickerMonthViewProps };
